module.exports = __webpack_public_path__ + "img/member-icon4.297259de.png";